import {handleActions} from 'redux-actions';
import {
    SET_DELIVERY_MANAGER_MANIFEST,
    RESET_DELIVERY_MANAGER_MANIFEST,
} from './DeliveryManagerManifestAction';
import {DeliveryManagerManifestState} from '../DeliveryManagerManifestTypes';

export const initialState = {
    isLoading: true,
    url: ''
};

export const setDeliveryManagerManifest = (
    state: DeliveryManagerManifestState,
    {payload}: any
) => {
    const {url} = payload;

    return {
        isLoading: false,
        url,
    };
};

export const resetDeliveryManagerManifest = () => {
    return initialState;
}

const handlers = {
    [SET_DELIVERY_MANAGER_MANIFEST]: setDeliveryManagerManifest,
    [RESET_DELIVERY_MANAGER_MANIFEST]: resetDeliveryManagerManifest,
};

export default handleActions(handlers, initialState);
